import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../config/app-settings';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '../components/card/card';
import { useDispatch, useSelector } from 'react-redux';
import { getListLiveLean } from '../redux/action/liveDetectionAction';
import { getRoleModuleById } from '../redux/action/roleModuleAction';
import findItem from '../helperFindPath';
import { SelectNonForm } from '../components/InputComponent';
import { getSitesList } from '../redux/action/sitesAction';
import ButtonComponent from '../components/ButtonComponent';

const LiveDetectionLean = () => {
  let {pages} = useParams();  
  const { dataLiveLean } = useSelector((state) => state.liveDetection );
  const { dataSitesList } = useSelector( (state) => state.sites );
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth)
  const [filterSites, setFilterSites] = useState('')
  const [optionSites, setOptionSites] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [components, setComponents] = useState([])
  const [lastPage, setLastPage] = useState()
  const [page, setPage] = useState()
	const param = {
		token: user.access_token,
    page: 0,
    filter: {
      siteId: filterSites,
    },
	}
	useEffect(() => {
    setComponents([]);
    if(pages === undefined){
      param.page = 0
      setPage(parseInt(0))
    }else{
      param.page = pages
      setPage(parseInt(pages))
    }
		dispatch(getListLiveLean(param));
	}, [filterSites]);
	const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')

  const [delayedRender, setDelayedRender] = useState([]);

  useEffect(() => {
    if(dataLiveLean !== ''){
      let lastPage = dataLiveLean.totalPages - 1
      dataLiveLean.content.map((key, index)=>{
        setTimeout(()=>{
          addComponent(key,index)
        }, index * 1000)
      })
      setLastPage(lastPage)
    }
  }, [dataLiveLean]);
  const addComponent = (key, index) => {
    setComponents(prevComponents => {
      const newComponent = (
          <Card className= 'mb-3'>
            <CardHeader>
              <span> {key.detailCamera.location + " - " + key.detailSite.nameSite } </span>
            </CardHeader>
            <CardBody>
              <img src={'http://103.165.198.186:5001/stream/'+key.id} alt='' style={{ width: '100%'}}/>
            </CardBody>
          </Card>
      );
      return [...prevComponents, newComponent];
    });
  };

  // const chunkedDelayedRender = Array.from(
  //   { length: Math.ceil(delayedRender.length / 3) },
  //   (_, index) => delayedRender.slice(index * 3, index * 3 + 3)
  // );
  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH LOKASI JPO -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])
  useEffect(() => {
    dispatch(getSitesList(param));
  }, []);

  const onChange = async (e, field) => {
    // console.log(e.target.value)
    if (field === 'siteId') {
      setFilterSites(e.target.value)
    }
  }
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      let slice = pathname.split('/')[0]+'/'+pathname.split('/')[1]
      const findPath = findItem(dataRoleModuleSidebar, slice)
      // console.log(findPath)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }else{
        setDataObjPath('403')
      }
    }
  },[dataRoleModuleSidebar])

  if(dataObjPath === ''){
    return (
      null
    )
  }else if(dataObjPath === '403'){
    return (
      <div>
        <h2>403: Forbidden</h2>
        <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
      </div>
    )
  }else{
	return (
		<div>
			{dataByIdRoleModule.read ? (
				<div className="row">
              <div className="col-md-12" style={{ textAlign: 'right', alignSelf: 'center', marginBottom: '15px' }}>
                <SelectNonForm 
                  onChange={(e) => {
                    setFilterSites(e.target.value)
                  }}
                  name="type"
                  id="type"
                  value={filterSites}
                  option={optionSites}  
                />
              </div>
              {components.map((component, index) => (
                <div className="col-md-4" key={index}>
                  {component}
                </div>
              ))}
                {filterSites === '' && (
                  <div className="row">
                    <div className="col-xl-6"></div>
                    <div className="col-xl-6" style={{ textAlign: 'right', alignSelf: 'center' }}>
                      {page !== 0 && (
                        <a href={'/deteksi-langsung/pendeteksi-orang-bersandar/'+ (page-1)}>
                        <ButtonComponent
                          color="white"
                          backgroundColor="#3003fc"
                          backgroundHover="#2404b5"
                          style={{ marginRight: 5 }}
                          // onClick={(e)=> setCurrentPage(currentPage-1)}
                        >
                          Sebelumnya 
                        </ButtonComponent>
                      </a>
                      )}
                      {lastPage !== page ? (
                        <a href={'/deteksi-langsung/pendeteksi-orang-bersandar/'+ (page+1)}>
                          <ButtonComponent
                            color="white"
                            backgroundColor="#3003fc"
                            backgroundHover="#2404b5"
                            // onClick={(e)=> setCurrentPage(currentPage+1)}
                          >
                            Selanjutnya
                          </ButtonComponent>
                        </a>
                      ): null }
                      </div>
                  </div>
                )}
				</div>
			): null}
    	</div>
	)
	}
}

export default LiveDetectionLean